import type { ReactNode } from 'react';

/**
 * A PERSON'S NAME, KEPT TO ITS OWN BOX — the name a player gave at sign-up, or the name read off
 * their ID.
 *
 * Both come from outside this console: the player typed one, and CIRA read the other off a
 * photograph. A name may be written right to left, and the sign-up rule allows a few accents
 * stacked on one letter, so a name set inline could reorder the words beside it or paint its
 * marks over the row above.
 *
 * TWO ELEMENTS, EACH WITH ONE JOB. The `<bdi>` isolates the name's direction from the text around
 * it, so its own words run right to left where they are written that way. The block around it
 * clips whatever the name draws outside its own box and wraps a long name rather than widening
 * the row — and, being in the page's direction, it lines the name up as the text around it is
 * lined up: under its label in a comparison, to the right in a definition row. (A single
 * right-to-left block would right-align itself under a left-aligned label; `text-align:
 * match-parent`, which would undo that, is not honoured by Chromium.)
 */
export function PersonName({ children }: { children: ReactNode }) {
  return (
    <div style={{ overflow: 'hidden', overflowWrap: 'anywhere' }}>
      <bdi>{children}</bdi>
    </div>
  );
}
